import { render, staticRenderFns } from "./movie_France.vue?vue&type=template&id=ddffdee0&scoped=true"
import script from "./movie_France.vue?vue&type=script&lang=js"
export * from "./movie_France.vue?vue&type=script&lang=js"
import style0 from "./movie_France.vue?vue&type=style&index=0&id=ddffdee0&prod&scoped=true&lang=css"
import style1 from "./movie_France.vue?vue&type=style&index=1&id=ddffdee0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddffdee0",
  null
  
)

export default component.exports